import { io } from 'socket.io-client';

// "undefined" means the URL will be computed from the `window.location` object
const baseURL = process.env.REACT_APP_BASE_URL || 'http://143.110.243.16:4000';
// const baseURL = 'http://64.227.173.102:4000' // production
// const baseURL = 'https://neelspurchase.com:4001' // Live
export const socket = io(baseURL, {
	transports: ['websocket'], // optional, forces WebSocket transport
});

// ADD THIS
socket.on('connect', () => {
	console.log('✅ Socket connected:', socket?.id);

	const user = localStorage?.getItem('neels_authUsername')
		? JSON?.parse(localStorage?.getItem('neels_authUsername') || '{}')
		: null;

	if (user?._id || user?.id) {
		socket.emit('authenticate', {
			userId: user?._id || user?.id, // must be Mongo _id
			socketId: socket?.id, // backend expects this
		});

		console.log('🔐 Socket authenticated for:', user?.email);
	}
});
